module.exports = __webpack_public_path__ + "static/media/MPGS.34addc6a.png";